"use client"

import { Button } from '@/components/ui/button';
import { Filter } from 'lucide-react';
import { useRouter } from 'next/navigation';

export function ShopEmptyState() {
  const router = useRouter();

  return (
    <div className="text-center py-12">
      <div className="text-muted-foreground mb-4">
        <Filter className="h-12 w-12 mx-auto mb-4 opacity-50" />
        <h3 className="text-lg font-semibold mb-2">No products found</h3>
        <p className="text-sm">Try adjusting your filters or search criteria.</p>
      </div>
      <Button 
        variant="outline" 
        onClick={() => router.push('/shop')}
      >
        Clear all filters
      </Button>
    </div>
  );
} 